export default __webpack_public_path__ + "static/media/ods16.c45342c6.svg";